import type { Injector } from '@angular/core';
import {
  createBulkEditSectionsToken,
  FIELD_PERMISSION_CHECKER,
  type BulkEditSection,
  type BulkPatchFragment,
  type FieldPermissionChecker,
} from '@zag/ui';

function hasPermission(permission: string): (injector: Injector) => boolean {
  return injector => injector.get<FieldPermissionChecker>(FIELD_PERMISSION_CHECKER).hasPermission(permission);
}
import { PersonRolesBulkSectionComponent } from './person-roles-bulk-section/person-roles-bulk-section.component';
import { MembersBulkSectionComponent } from './members-bulk-section/members-bulk-section.component';

export const GROUPS_BULK_EDIT_SECTIONS_TOKEN = createBulkEditSectionsToken('groups');

interface RolesState {
  roleIds: string[];
  mode: 'add' | 'remove';
}

interface MembersState {
  userIds: string[];
}

export const GROUPS_BULK_EDIT_SECTIONS: BulkEditSection[] = [
  {
    id: 'bulk-roles',
    icon: 'shield',
    titleKey: 'bulkEdit.groups.roles.title',
    priority: 10,
    component: PersonRolesBulkSectionComponent,
    previewLabelKey: 'bulkEdit.groups.roles.preview',
    appliesToArrayField: true,
    buildPatchFragment(state: unknown): BulkPatchFragment {
      const s = state as RolesState;
      if (!s?.roleIds?.length) return {};
      return {
        arrayOps: {
          roles: { op: s.mode === 'remove' ? 'remove' : 'append', items: s.roleIds.map(roleId => ({ roleId })) },
        },
      };
    },
    visibilityCheck: hasPermission('rbac:roles:read'),
    editCheck: hasPermission('rbac:groups:update'),
  },
  {
    id: 'bulk-members',
    icon: 'person_add',
    titleKey: 'bulkEdit.groups.members.title',
    priority: 20,
    component: MembersBulkSectionComponent,
    previewLabelKey: 'bulkEdit.groups.members.preview',
    appliesToArrayField: true,
    buildPatchFragment(state: unknown): BulkPatchFragment {
      const s = state as MembersState;
      if (!s?.userIds?.length) return {};
      return { arrayOps: { members: { op: 'append', items: s.userIds.map(userId => ({ userId })) } } };
    },
    visibilityCheck: hasPermission('rbac:users:read'),
    editCheck: hasPermission('rbac:groups:update'),
  },
];
